import { useState } from "react";
import { postVideoMessageToNative } from "src/components-mui/modals/video-modal/video-modal.native";
import { useIsCallerContentApp } from "src/lib/native-bridge/hooks/use-is-content-app";

interface IUseVideoModalParams {
    videoUrl: string;
    title: string;
}

const shouldDelegateVideoToReactNative = (): boolean => {
    if (globalThis.window === undefined) {
        return false;
    }

    return Boolean(globalThis.window.reactNativeFeatureFlags?.delegateVideoToReactNative);
};

export const useVideoModal = ({ videoUrl, title }: IUseVideoModalParams) => {
    const [isOpen, setIsOpen] = useState(false);
    const isCallerContentApp = useIsCallerContentApp();

    const open = () => {
        if (isCallerContentApp && shouldDelegateVideoToReactNative()) {
            const isDelegatedToNative = postVideoMessageToNative({ videoUrl, title });
            if (isDelegatedToNative) {
                return;
            }
        }
        setIsOpen(true);
    };

    const close = () => {
        setIsOpen(false);
    };

    return { isOpen, open, close };
};
